import type { QuerySettings } from '@customTypes/index';
import { useQuery } from '@tanstack/react-query';

import type { ArtistWorkItemsListRequest } from '@/features/work/api/artist-work-items-list/request';
import { artistWorkItemsList } from '@/features/work/api/artist-work-items-list/request';

export const useArtistWorkItemsListQuery = (
  params: ArtistWorkItemsListRequest,
  settings?: QuerySettings<typeof artistWorkItemsList>
) =>
  useQuery({
    queryKey: ['ArtistWorkItemsList', params.profileId, params.status],
    queryFn: () =>
      artistWorkItemsList({
        params,
        config: settings?.config
      }),
    ...settings?.options
  });
